/**
 * Estimate token count using character-based heuristic.
 * Average ratio for English text with GPT/Claude tokenizers is ~4 chars per token.
 * This avoids bundling the 5.5 MB js-tiktoken dictionary into frontend builds.
 */
export function getTokenCount(text: string): number {
  const cleanedText = text.replace(/<\|endoftext\|>/g, "")
  return Math.ceil(cleanedText.length / 4)
}
